var { Platform } = require('react-native');

if (Platform.OS === 'web') {
  module.exports = {
    readFile: (url) =>
    {
      return fetch(url, {
        method: 'get',
      })
      .then((response) => response.text())
      .then((responseText) =>
      {
        return responseText;
      })
    },
    writeFile: () => Promise.resolve({}),
    mkdir: () => Promise.resolve({}),
    readDir: () => Promise.resolve({}),
    exists: (imageSrc) =>
    {
      var callback = null;
      var result = {
        then:(newCallback)=>
        {
          callback = newCallback;
        }
      }
      var img = new Image();
      img.onload = ()=>
      {
        if( callback != null ) callback(true);
      };
      img.onerror = ()=>
      {
        if( callback != null ) callback(false);
      };
      img.src = imageSrc;

      return result;
    },
    unlink: () => {}
  }
}
